import { AddressJusoDto } from "src/dtos/address/addressApiResponseDto";

interface Props {
    data: AddressJusoDto;
    onSelect: (data: AddressJusoDto) => void;
}

const AddressItem = ({ data, onSelect }: Props) => {

    return (
	<button className="flex flex-col gap-[4px] w-full p-[10px] border-[1px] rounded-[8px]" onClick={() => onSelect(data)}>
        <p className="font-bold text-[14px] flex">
            {data.roadAddr}
        </p>
        <div className="flex gap-[8px]">
            <p className="bg-gray-400 text-white text-[10px] flex items-center px-[4px] rounded-[8px]">
                지번주소
            </p>
            <p className="text-[14px]">
                {data.jibunAddr}
            </p>
        </div>
        <div className="flex gap-[8px]">
            <p className="bg-gray-400 text-white text-[10px] flex items-center px-[4px] rounded-[8px]">
                우편번호
            </p>
            <p className="text-[12px]">
                {data.zipNo}
            </p>
        </div>
    </button>
    )
}

export default AddressItem;